import ComicCard from '@/components/base/ComicCard';
import type { Comic } from '@/mocks/types';

interface LatestUpdateSectionProps {
  comics: Comic[];
}

export default function LatestUpdateSection({ comics }: LatestUpdateSectionProps) {
  const newComics = comics.filter((c) => c.isNew).slice(0, 8);

  return (
    <section id="latest" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              最新更新
            </h2>
          </div>
          <span className="text-sm text-foreground-500 whitespace-nowrap">每日准时上新</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {newComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}